import React, { createContext, useContext } from 'react';
import { Grid, Stack, Button, Card } from '@mui/material';
import { Control, FieldErrors, FieldValues } from 'react-hook-form';

interface FormContextType<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>;
    errors: FieldErrors<TFieldValues>;
    isSending: boolean;
    disableErrorMessages: boolean;
}

const FormContext = createContext<FormContextType<any> | undefined>(undefined);

export function useFormTemplateContext<TFieldValues extends FieldValues>() {
    const context = useContext(FormContext as React.Context<FormContextType<TFieldValues>>);
    if (!context) {
        throw new Error('FormField must be used within a FormFields');
    }
    return context;
}

interface FormFieldsProps<TFieldValues extends FieldValues> extends FormContextType<TFieldValues> {
    children: React.ReactNode;
}

export function FormFields<TFieldValues extends FieldValues>({ children, control, errors, isSending, disableErrorMessages = false }: FormFieldsProps<TFieldValues>) {
    return (
        <FormContext.Provider value={{ control, errors, isSending, disableErrorMessages }}>
            <Stack spacing={2}>
                {children}
            </Stack>
        </FormContext.Provider>
    );
}